import { SWReactIcons } from "@similarweb/icons";
import { PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { sharedTopicIconKeys } from "../automationKeys";
import { SHARE_TOOLTIP } from "../texts";

type SharedTopicIconSchema = {
    ownerName: string;
};

export const SharedTopicIcon = ({ ownerName }: SharedTopicIconSchema) => (
    <PlainTooltip tooltipContent={translate(SHARE_TOOLTIP, { ownerName })}>
        <span data-automation={sharedTopicIconKeys.wrapper}>
            <SWReactIcons
                iconName="social-share"
                size="xs"
            />
        </span>
    </PlainTooltip>
);

SharedTopicIcon.displayName = "SharedTopicIcon";
